import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import axios from './axios';

class Transaction extends Component {

    componentDidMount() {
        axios.get(process.env.REACT_APP_API.concat('public/transactions?limit=20&start=1')).then(res => {
            this.setState(Object.assign(
                this.state, {
                ...this.state,
                transaction: res.data,
                pagination: {
                    ...this.state.pagination,
                    current_page: 1,
                    pages: (Math.floor((res.data.total - 1) / 10)) + 1
                }
            }
            ))
        }).catch(err => {
        })
    }
    constructor() {
        super();
        this.state = {
            token: {
                access_token: "",
                refresh_token: ""
            },
            transaction: {
                total: 0
            },
            pagination: {
                tag_pages: "",
                table: <tr><td></td><td></td><td></td><td></td></tr>,
                current_page: "",
                pages: ""
            }
        };
        this.select_page = this.select_page.bind(this);
        this.Nextpage = this.Nextpage.bind(this);
        this.Backpage = this.Backpage.bind(this);
        this.amount2point = this.amount2point.bind(this);
        this.formatMoney = this.formatMoney.bind(this);
        this.formatDate = this.formatDate.bind(this);
    }
    formatDate(dateString) {
        var thisDate = dateString.split('-');
        var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
        return newDate
    }
    select_page(event) {
        var to = ((event.target.value * 10) - 9);
        axios.get(process.env.REACT_APP_API.concat('public/transactions?limit=10&start=').concat(to)).then(res => {
            this.setState(Object.assign(
                this.state, {
                ...this.state,
                transaction: res.data,
                pagination: {
                    ...this.state.pagination,
                    current_page: parseInt(event.target.value),
                }
            }
            ))
        })
    }
    formatMoney(amount) {
        return Intl.NumberFormat('la-LA').format(amount);
    }
    Nextpage(event) {
        var to = (this.state.pagination.current_page + 1);
        axios.get(process.env.REACT_APP_API.concat('public/transactions?limit=10&start=').concat(String(to * 10 - 9))).then(res => {
            this.setState(Object.assign(
                this.state, {
                ...this.state,
                transaction: res.data,
                pagination: {
                    ...this.state.pagination,
                    current_page: to,
                }
            }
            ))
        })

    }
    amount2point(value) {
        var point;
        point = Math.round(parseInt(value) / 8000)
        return (point)
    }
    Backpage(event) {
        var to = (this.state.pagination.current_page - 1);
        axios.get(process.env.REACT_APP_API.concat('public/transactions?limit=10&start=').concat(String(to * 10 - 9))).then(res => {
            this.setState(Object.assign(
                this.state, {
                ...this.state,
                transaction: res.data,
                pagination: {
                    ...this.state.pagination,
                    current_page: to,
                }
            }
            ))
        })
    }
    render() {
        const { t } = this.props;
        var table = [];
        var pages = [];
        var endtable = [];
        var date;
        var keys;
        if (this.state.transaction.total) {
            for (keys in this.state.transaction.transactions) {
                date = this.state.transaction.transactions[keys].date.substring(0, 10);
                table.push(
                    <tr className="active-row">
                        <td>{this.formatDate(date)}</td>
                        <td>{this.formatMoney(this.state.transaction.transactions[keys].grand_total)} {t('lak')}</td>
                        <td>{this.amount2point(this.state.transaction.transactions[keys].amount)} {t('point')}</td>
                    </tr>)
            }
            if (1 === (this.state.pagination.current_page)) {
                pages.push(<li className="page-item disabled" key="back"><button className="page-link" >&lt;</button></li>)
            } else {
                pages.push(<li className="page-item " key="back"><button className="page-link" onClick={this.Backpage}>&lt;</button></li>)
            }
            for (keys = 1; keys <= (Math.floor((this.state.transaction.total - 1) / 10) + 1); keys++) {
                if (keys === (this.state.pagination.current_page)) {
                    pages.push(<li className="page-item" aria-current="page" key={keys}><span className="page-link">{keys}</span></li>)
                } else {
                    pages.push(<li className="page-item" key={keys}><button className="page-link" value={keys} onClick={this.select_page}>{keys}</button></li>)
                }
            }
            if ((Math.floor((this.state.transaction.total - 1) / 10) + 1) <= this.state.pagination.current_page) {
                pages.push(<li className="page-item disabled" key="next"><button className="page-link" >&gt;</button></li>)
            } else {
                pages.push(<li className="page-item" key="next"><button className="page-link" onClick={this.Nextpage}>&gt;</button></li>)
            }
        } else {
            endtable.push(
                <div className="divcenter">
                    <figure className="text-center">
                        <blockquote className="blockquote">
                            <p>{t('notrans')}</p>
                        </blockquote>
                    </figure>
                </div>
            )
        }
        return (
            <>
                <div className="row fix-table">
                    <div className="card card-info">
                        <h2 className="card-title">{t('transachistory')}</h2>
                        <div className="table-responsive">
                            <table className="table styled-table">
                                <thead>
                                    <tr>
                                        <th>{t('dates')}</th>
                                        <th>{t('total')}</th>
                                        <th>{t('amountpoint')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {table}
                                </tbody>
                            </table>
                            {endtable}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <nav aria-label="Page navigation example">
                        <ul className="pagination justify-content-end">
                            {pages}
                        </ul>
                    </nav>
                </div>
            </>
        )
    }

}
export default withTranslation()(Transaction);